<template>
  <div>
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Search sites</h5>
        <div class="ibox-tools">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content col-lg-12">
        <div class="search col-lg-12">
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="iUrl">Url:</label></div>
            <div class="col-lg-8"><input type="text" name="url" id="iUrl" ref="url" class="col-lg-8" @keydown.enter="searchSites"></div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="iPostsFrom">Posts:</label></div>
            <div class="col-lg-8">
              <input type="number" min="0" name="" id="iPostsFrom" placeholder="from" class="col-lg-4" ref="postsFrom" @keydown.enter="searchSites">
              <input type="number" min="0" name="" id="iPostsTo" placeholder="to" class="col-lg-4" ref="postsTo" @keydown.enter="searchSites">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="trafficFrom">Traffic</label></div>
            <div class="col-lg-8">
              <input type="number" min="0" name="" id="trafficFrom" placeholder="from" class="col-lg-4" ref="trafficFrom" @keydown.enter="searchSites">
              <input type="number" min="0" name="" id="trafficTo" placeholder="to" class="col-lg-4" ref="trafficTo" @keydown.enter="searchSites">
            </div>
          </div>
        </div>
        <div class="search col-lg-12">
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="iRDFrom">RD</label></div>
            <div class="col-lg-8">
              <input type="number" min="0" name="" id="iRDFrom" placeholder="from" class="col-lg-4" ref="rdFrom" @keydown.enter="searchSites">
              <input type="number" min="0" name="" id="iRDTo" placeholder="to" class="col-lg-4" ref="rdTo" @keydown.enter="searchSites">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="iTFFrom">TF</label></div>
            <div class="col-lg-8">
              <input type="number" min="0" name="" id="iTFFrom" placeholder="from" class="col-lg-4" ref="tfFrom" @keydown.enter="searchSites">
              <input type="number" min="0" name="" id="iTFTo" placeholder="to" class="col-lg-4" ref="tfTo" @keydown.enter="searchSites">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="iDAFrom">DA</label></div>
            <div class="col-lg-8">
              <input type="number" min="0" name="" id="iDAFrom" placeholder="from" class="col-lg-4" ref="daFrom" @keydown.enter="searchSites">
              <input type="number" min="0" name="" id="iDATo" placeholder="to" class="col-lg-4" ref="daTo" @keydown.enter="searchSites">
            </div>
          </div>
        </div>
        <div class="search col-lg-12">
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="iLang">Language:</label></div>
            <div class="col-lg-8">
              <v-select name="language" id="iLang" ref="language" :options="this.languages" multiple="multiple" @change="searchSites" v-model="selectedLangs">
              </v-select>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-4"><label for="trafficFrom">Category</label></div>
            <div class="col-lg-8">
              <v-select name="category" id="iCategory" multiple :options="this.categories" v-model="selectedCategories">
              </v-select>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="col-lg-4"><button class="btn btn-sm btn-primary" @click="searchSites">Search</button></div>
          <button class="btn btn-sm btn-default pull-right" @click="resetFilters">Reset filters</button>
        </div>
        <div class="table-responsive col-lg-12">
          <table class="table table-striped table-bordered table-hover dataTables-example">
            <thead>
            <tr>
              <th>Url</th>
              <th>Posts</th>
              <th>Pages</th>
              <th>Lang</th>
              <th>Category</th>
              <th>RD</th>
              <th>TF</th>
              <th>DA</th>
              <th>Traffic</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="site in sites" :key="site.id">
              <td><router-link :to="'/site/' + site.id">{{ site.url }}</router-link></td>
              <td>{{ site.posts }}</td>
              <td>{{ site.pages }}</td>
              <td>{{ site.lang }}</td>
              <td>{{ site.stats.ttf0 }}</td>
              <td>{{ site.stats.rd }}</td>
              <td>{{ site.stats.tf }}</td>
              <td>{{ site.stats.da }}</td>
              <td>{{ site.traffic }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th>Url</th>
              <th>Posts</th>
              <th>Pages</th>
              <th>Lang</th>
              <th>Category</th>
              <th>RD</th>
              <th>TF</th>
              <th>DA</th>
              <th>Traffic</th>
            </tr>
            </tfoot>
          </table>
        </div>
        <div v-if="sitesLoaded">
          <button class="btn btn-primary btn-sm pull-right" @click="searchSites(false)">Load more</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Sites',
  data () {
    return {
      sites: [],
      searchName: '',
      activeTags: ['active'],
      propName: '',
      propVal: '',
      sitesLoaded: false,
      offset: 0,
      limit: 100,
      languages: [],
      categories: [],
      selectedLangs: [],
      selectedCategories: []
    }
  },
  mounted () {
    this.getLangs()
    this.getCategories()
    this.dt = $('.dataTables-example').DataTable({
      pageLength: 25,
      responsive: true,
      dom: 'Bfrtip',
      buttons: [
        'copy', 'csv', 'excel', 'pdf'
      ],
      render: (data, type, row, meta) => {
        return '<a href="/' + data + '">' + data + '</a>'
      }
    })
    document.getElementsByClassName('dataTables_filter')[0].getElementsByTagName('input')[0].classList.add('form-control', 'input-sm')
  },
  methods: {
    getLangs () {
      axios.get(process.env.API + '/languages').then(response => {
        for (let key in response.data.data) {
          this.languages.push({
            value: key,
            label: response.data.data[key]
          })
        }
      })
    },
    getCategories () {
      axios.get(process.env.API + '/categories').then(response => {
        for (let key in response.data) {
          this.categories.push({
            value: key,
            label: response.data[key]
          })
        }
      })
    },
    searchSites (clear = true) {
      if (clear) {
        this.dt.clear()
        this.offset = 0
      }
      let langs = []
      let cats = []
      this.selectedLangs.forEach((obj) => {
        langs.push(obj.value)
      })
      this.selectedCategories.forEach((obj) => {
        cats.push(obj.label)
      })
      let query = 'url=' + this.$refs.url.value +
        '&postsFrom=' + this.$refs.postsFrom.value +
        '&postsTo=' + this.$refs.postsTo.value +
        '&language=' + langs +
        '&category=' + cats +
        '&rdFrom=' + this.$refs.rdFrom.value +
        '&rdTo=' + this.$refs.rdTo.value +
        '&tfFrom=' + this.$refs.tfFrom.value +
        '&tfTo=' + this.$refs.tfTo.value +
        '&daFrom=' + this.$refs.daFrom.value +
        '&daTo=' + this.$refs.daTo.value +
        '&trafficFrom=' + this.$refs.trafficFrom.value +
        '&trafficTo=' + this.$refs.trafficTo.value +
        '&limit=' + 100 +
        '&offset=' + this.offset
      this.offset += this.limit
      axios.get(process.env.API + '/sites?' + query).then(response => {
        if (!response.data.data[0]) {
          this.dt.draw(false)
          return
        }
        response.data.data.forEach((row) => {
          this.dt.row.add([
            '<a href="/site/' + row.id + '">' + row.url + '</a>',
            row.posts ? parseInt(row.posts) : 0,
            row.stats.pagecount ? parseInt(row.stats.pagecount) : 0,
            row.language ? row.language : '',
            row.stats.ttf0,
            parseInt(row.stats.rd),
            parseInt(row.stats.tf),
            parseInt(row.stats.da),
            parseInt(row.stats.traffic)
          ]).draw(false)
        })
        this.sitesLoaded = true
      }).catch((e) => {
        console.log(e)
      })
    },
    getSites () {
      axios.get(process.env.API + '/sites?name=' + this.searchName + '&tags=' + this.activeTags.join(',') + '&props[' + this.propName + ']=' + this.propVal)
        .then(response => {
          this.sitestabSites = []
          response.data.forEach((row) => {
            this.dt.row.add([
              '<a href="/site/' + row.id + '">' + row.id + '</a>',
              row.url,
              row.data.postcount ? parseInt(row.data.postcount) : 0,
              row.data.pagecount ? parseInt(row.data.pagecount) : 0,
              row.data.lang ? row.data.lang : '',
              row.data.category ? row.data.category : '',
              row.data.rd ? parseInt(row.data.rd) : 0,
              row.data.tf ? parseInt(row.data.tf) : 0,
              row.data.da ? parseInt(row.data.da) : 0,
              row.data.traffic ? parseInt(row.data.traffic) : 0
            ]).draw(false)
          })
          this.sitesLoaded = true
        }).catch(e => {
          console.log(e)
        })
      // this.dt.clear()
      if (this.dt) {
        this.dt.rows.add(this.sites)
        this.dt.draw()
      }
    },
    resetFilters () {
      $('.search input, .search select').val('')
      this.dt.clear()
      this.dt.draw(false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Sites/Sites.vue